function isWeb3Provider(provider) {
    return 'provider' in provider;
}
function isWalletConnectProvider(provider) {
    return provider.isWalletConnect;
}
export function getPeerMeta(provider) {
    var _a;
    if (isWeb3Provider(provider) && isWalletConnectProvider(provider.provider)) {
        return (_a = provider.provider.connector.peerMeta) !== null && _a !== void 0 ? _a : undefined;
    }
    else {
        return;
    }
}
